<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
                    <van-col span="12">
                        <div class="banner-title">发现</div>
                    </van-col>
                    <van-col span="6" @click="toSelectCity">
                        <div class="find">
                            {{area}}<img class="find-icon" src="@/assets/theme/light/share/05find/01arr.png">
                        </div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content-body">
            <div class="friend-box">
                <div class="friend-item" v-for="item in friendList" @click="toFriendDesc(item)" v-if="item.userId != userId">
                    <img class="friend-icon" :src="item.userAvatar ? item.userAvatar : defaultImg">
                    <div class="friend-name">{{item.userName}}</div>
                    <div class="apply-btn" v-if="!item.status" @click="toConfirm(item)">邀请TA</div>
                    <div class="apply-btn is-friend" v-if="item.status">互为好友</div>
                </div>
            </div>
            <div class="none-box" v-if="friendList.length == 0 && !isLoading">
                <van-icon class="none-icon" name="info-o"/>
                <div class="none-text">没有找到，换个地区试试~</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'find',
        data() {
            return {
                theme: 'light',
                area: localStorage.getItem('userArea') ? localStorage.getItem('userArea') : '北京',
                pageSize: 15,
                pageNum: 0,
                friendList: [],
                isLoading: false,
                defaultImg: require('@/assets/share/home/noImg.png'),
                friendCount: 0,
                userId: localStorage.getItem('userId')
            }
        },
        mounted() {
            if (this.$route.query.theme) {
                this.theme = this.$route.query.theme
            }
            let selectCity = localStorage.getItem('selectCity')
            if (selectCity) {
                this.area = selectCity
            }
            this.getFriendList();
            this.bindScroll();
        },
        methods: {
            back() {
                this.$router.back();
            },
            toSelectCity() {
                this.$router.push({
                    name: 'selectCityLight',
                    query: {
                        theme: this.theme
                    }
                })
            },
            getFriendList() {
                this.pageNum++;
                this.isLoading = true;
                this.$api.share.discoverMembers({
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    area: this.area
                }).then(res => {
                    this.friendCount = res.info.count
                    this.friendList.push(...res.info.items);
                    this.isLoading = false;
                })
            },
            // 滚动回调函数
            scrollHande() {
                // 节流
                if (this.isLoading) return
                // 获取内容高度
                var scrollH = document.documentElement.scrollHeight
                // 获取窗口高度
                var innerH = window.innerHeight
                // 获取滚出去的内容高度
                var top = document.body.scrollTop || document.documentElement.scrollTop
                // 当内容还剩余200的高度未滚出的时候发送请求
                if (scrollH - top - innerH < 200) {
                    // 发送请求
                    this.getFriendList();
                }
            },
            // 绑定scroll事件
            bindScroll() {
                window.addEventListener('scroll', this.scrollHande)
            },
            // 清除scroll事件
            clearScroll() {
                window.removeEventListener('scroll', this.scrollHande)
            },
            toFriendDesc(item) {
                localStorage.setItem('sharerId', item.userId);
                this.$router.push({
                    name: 'friendDescLight',
                    query: {
                        theme: this.theme
                    }
                })
            },
            toConfirm(item) {
                localStorage.setItem("addUser", JSON.stringify(item));
                this.$router.push({
                    name: 'confirmLight',
                    params: {
                        type: 'qr'
                    },
                    query: {
                        theme: this.theme
                    }
                })
            }
        },
        // 页面销毁之前，清除scroll
        destroyed() {
            this.clearScroll()
        }
    }
</script>

<style scoped>

    .friend-item {

    }

    .friend-icon {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        margin-left: 37px;
        margin-top: 15px;
        margin-bottom: 15px;
        vertical-align: bottom;
    }

    .friend-name {
        color: var(--text-color-1);
        font-size: 15px;
        display: inline-block;
        line-height: 44px;
        margin-left: 8px;
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .apply-btn {
        width: 54px;
        height: 21px;
        border-radius: 5px 5px 5px 5px;
        border: 2px solid var(--text-color-1);
        font-size: 12px;
        line-height: 21px;
        color: var(--text-color-1);
        float: right;
        text-align: center;
        margin-right: 15px;
        margin-top: 24px;
    }

    .new-add {
        height: 66px;
        width: 345px;
        margin: 15px auto 0;
        background-color: #202020;
        border-radius: 4px;
    }

    .friend-count {
        color: rgba(255, 255, 255, 0.9);
        opacity: 0.6;
        text-align: center;
        font-size: 14px;
        margin-bottom: 15px;
    }

    .img-box {
        width: 44px;
        height: 44px;
        background: #20D38F;
        display: inline-block;
        border-radius: 50%;
        text-align: center;
        vertical-align: bottom;
        position: absolute;
        left: 20px;
        top: 11px;
    }

    .new-icon {
        width: 21px;
        height: 21px;
        position: absolute;
        left: 32px;
        top: 22px;
    }

    .new-item {
        position: relative;
        height: 66px;
    }

    .new-num {
        position: absolute;
        right: 22px;
        top: 26px;
        display: inline-block;
        font-size: 12px;
    }

    .new-name {
        position: absolute;
        top: 26px;
        left: 77px;
        color: #ffffff;
        opacity: 0.9;
        font-size: 14px;
    }

    /deep/ .van-badge {
        border: none;
    }

    .find {
        color: var(--text-color-1);
        font-size: 15px;
        height: 45px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .find-icon {
        width: 16px;
        height: 16px;
        margin-left: 2px;
        margin-right: 15px;
    }

    .none-box {
        text-align: center;
        margin-top: 50px;
    }

    .none-icon {
        font-size: 40px;
        color: #707070;
    }

    .none-text {
        font-size: 15px;
        margin-top: 10px;
        opacity: 0.9;
        color: var(--text-color-1);
    }

    .is-friend {
        background-color: var(--bg-color-2);
        color: rgba(0,0,0,0.5);
        border: 2px solid var(--bg-color-2);
    }
</style>



// WEBPACK FOOTER //
// src/views/shareLight/05find.vue